import { Routes, Route } from 'react-router-dom'
import TopupList from './TopupList'
import { useStateContext } from 'context/ContextProvider';
import { Role } from 'types';
import Page404 from 'views/errors/Page404';

const TopupsRoutes = () => {

  const { user } = useStateContext();

  if( ![Role.Admin,Role.Advisor,Role.Manager,Role.Accounting].some(value => user?.roles.includes(value))){
    return <Page404 />
  }

  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={<TopupList />}
        />
      </Route>
    </Routes>
  )
}

export default TopupsRoutes
